import classNames from 'classnames';
import classes from './styles/listSidebarIndicatorButton.module.scss';

function ListFilterButtonCount({
	hasCompactIndicator,
	count,
	className,
}: {
	hasCompactIndicator?: boolean;
	count?: number;
	className?: string;
}) {
	const filterButtonCountClasses = classNames(classes.filterButtonCounter, {
		[classes.filterButtonCounter_tiny]: hasCompactIndicator,
	});
	const rootClasses = classNames(filterButtonCountClasses, className);

	return <span className={rootClasses}>{!hasCompactIndicator && count}</span>;
}

export { ListFilterButtonCount };
